import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PermintaanObatPaketSvc from "@/services/PermintaanObatPaket";

@Module({ store, dynamic: true, namespaced: true, name: "permintaan-obat-paket" })
class PermintaanObatPaketModule extends VuexModule {
  data: any = null;
  loading = false;

  @Mutation SET_DATA(val: any) {
    this.data = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(payload: { reg: string | number; jenisPaket: string }) {
    this.SET_LOADING(true);

    try {
      const dt = await PermintaanObatPaketSvc.getByRegister(payload.reg, payload.jenisPaket);
      const { data } = dt.data;
      this.SET_DATA(data);
    } catch {
      this.SET_DATA(null);
    }

    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await PermintaanObatPaketSvc.find(id);
      const { data } = dt.data;
      this.SET_DATA(data);
    } catch {
      this.SET_DATA(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_DATA(null);
  }
}

export const storePermintaanObatPaket = getModule(PermintaanObatPaketModule);
